import React, { Component, PropTypes } from 'react';
import * as B from 'react-bootstrap';
import ChatMessageGroup from './ChatMessageGroup';
import chatConfiguration from 'config';
import moment from 'moment';

const configuration = chatConfiguration.chat;

class ChatTextWraper extends Component {
  static heightReductionCompensation = 250;
  static heightCounterCompensation = 50;
  static CONTROLS_HEIGHT = 80;
  static AGENT_TYPING_HEIGHT = 30;
  static ENDED_HEIGHT = 40;
  static ENDED_VERTICAL_PADDING = 10;
  static PADDING = 0;
  static propTypes = {
    sendDisabled: PropTypes.bool.isRequired,
    queueProperties: PropTypes.object.isRequired,
    height: PropTypes.number,
    isMobile: PropTypes.bool.isRequired,
    ended: PropTypes.bool.isRequired,
    userIsTypingTimeout: PropTypes.number.isRequired,
    headerHeight: PropTypes.number,
    appHeight: PropTypes.number.isRequired,
    messageGroupingTreshold: PropTypes.number.isRequired,
    messages: PropTypes.object.isRequired,
    agentTyping: PropTypes.bool.isRequired,
    mailTranscriptSent: PropTypes.bool.isRequired,
    overrittenMailTranscriptLabel: PropTypes.string,
    onSendMailTranscript: PropTypes.func.isRequired,
    onSendMessage: PropTypes.func.isRequired,
    onUserTyping: PropTypes.func,
    onUserNotTyping: PropTypes.func,
    shrunk: PropTypes.bool,
    fullscreen: PropTypes.bool,
    hideSendButton: PropTypes.bool,
  }
  constructor(props) {
    super(props);

    this.state = {
      message: '',
      timer: undefined,
      typingTimer: undefined,
      scrollToBottomOnUpdate: false,
    };
  }
  get padding() {
    return this.props.shrunk || this.props.fullscreen ? 0 : ChatTextWraper.PADDING;
  }
  get endedHeight() {
    return ChatTextWraper.ENDED_HEIGHT + ChatTextWraper.ENDED_VERTICAL_PADDING * 2;
  }
  get wraperRendering() {
    return {
      padding: this.padding + 'px',
    };
  }
  get controlsRendering() {
    return { height: ChatTextWraper.CONTROLS_HEIGHT + 'px' };
  }
  get agentTypingRendering() {
    return { height: ChatTextWraper.AGENT_TYPING_HEIGHT + 'px' };
  }
  get messagesRendering() {
    let { shrunk, fullscreen } = this.props,
        counterCompensation = this.props.ended ? ChatTextWraper.heightCounterCompensation : 0;

    return {
      height: (shrunk || fullscreen
        ? this.props.height
          - (this.props.ended ? this.endedHeight : ChatTextWraper.CONTROLS_HEIGHT)
          - (!this.props.ended ? ChatTextWraper.AGENT_TYPING_HEIGHT : 0)
        : this.props.appHeight - this.props.headerHeight - ChatTextWraper.heightReductionCompensation + counterCompensation
      ) - this.padding * 2 + 'px',
    };
  }
  get endedRendering() {
    return {
      height: this.endedHeight + 'px',
      paddingTop: ChatTextWraper.ENDED_VERTICAL_PADDING + 'px',
      paddingBottom: ChatTextWraper.ENDED_VERTICAL_PADDING + 'px',
    };
  }
  changeMessage(e) {
    if (e.target.value !== '') {
      this.typing();
    }
    this.setState({ message: e.target.value });
  }
  sendMessage() {
    if (this.state.message !== '') {
      this.props.onSendMessage(this.state.message);
      this.notTypingAnymore();

      if (this.props.isMobile) {
        this.messageInput.setAttribute('disabled', 'true');
        setTimeout(() => {
          this.messageInput.removeAttribute('disabled');
          setTimeout(() => this.setState({ message: '' }), 0);
        }, 0);
      } else {
        this.setState({ message: '' });
      }
    }
  }
  typing() {
    if (this.props.onUserTyping) {
      this.props.onUserTyping();
    }
    clearTimeout(this.state.typingTimer);
    this.setState({ typingTimer: setTimeout(() => this.notTypingAnymore(), this.props.userIsTypingTimeout), });
  }
  notTypingAnymore() {
    if (this.props.onUserNotTyping) {
      this.props.onUserNotTyping();
    }
    clearTimeout(this.state.typingTimer);
  }
  componentDidMount() {
    this.setState({ timer: setInterval(() => this.forceUpdate(), 5000) });
  }
  componentWillUnmount() {
    clearInterval(this.state.timer);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.messages.size > this.props.messages.size) {
      this.setState({ scrollToBottomOnUpdate: true });
    }
  }
  componentDidUpdate() {
    if (this.state.scrollToBottomOnUpdate) {
       this.chatMessages.scrollTop = this.chatMessages.scrollHeight;
       this.setState({ scrollToBottomOnUpdate: false });
    }
  }
  render() {
    let previous, i = 0, j = -1,
        { hideSendButton, shrunk, fullscreen } = this.props,
        wraperClassName = 'chat-inner-wraper' + (shrunk ? ' shrunk' : '');

    return (
      <div className={wraperClassName} style={this.wraperRendering}>
        <div className="chat-messages" ref={c => this.chatMessages = c} style={this.messagesRendering}>
          {
            this.props.messages
              .groupBy(m => {
                if (previous === undefined) {
                  previous = m;
                  return i;
                }
                let newGroup = previous.from !== m.from
                  || previous.name !== m.name
                  || !m.sent.isBetween(previous.sent, moment(previous.sent).add(this.props.messageGroupingTreshold, 'minutes'))
                  || m.bsStyle !== previous.bsStyle;
                if (newGroup) {
                  previous = m;
                }
                return newGroup ? (i += 1) : i;
              })
              .map(ms => <ChatMessageGroup key={j += 1} messages={ms} />)
              .toArray()
          }
        </div>
        {
          !this.props.ended ? (
            <p className={'chat-agent-typing' + (this.props.agentTyping && !this.props.ended ? ' typing' : '')}
              style={this.agentTypingRendering}>
              { this.props.queueProperties.agentIsTypingMessage }
            </p>
          ) : undefined
        }
        {
          this.props.ended ? (
            <div className="chat-ended" style={this.endedRendering}>
              {
                this.props.queueProperties.showSendTranscript && !this.props.mailTranscriptSent ? (
                  <B.Button bsStyle="primary" onClick={this.props.onSendMailTranscript}>
                    { this.props.overrittenMailTranscriptLabel || this.props.queueProperties.sendEmailButtonLabel }
                  </B.Button>
                ) : undefined
              }
            </div>
          ) : (
            <div className={`chat-controls${hideSendButton ? ' send-hidden' : ''}`} style={this.controlsRendering}>
              <B.Grid fluid>
                <B.Row className="show-grid">
                  <B.Col xs={9} sm={9} md={9}>
                    <B.FormControl
                      disabled={this.props.sendDisabled}
                      autoFocus={!this.props.isMobile}
                      inputRef = {c => this.messageInput = c}
                      placeholder="Escriba aquí"
                      componentClass="textarea"
                      className="chat-textarea"
                      value={this.state.message}
                      onChange={this.changeMessage.bind(this)}
                      onKeyPress={e => {
                        if (e.which === 13) {
                          this.sendMessage.bind(this)();
                          e.preventDefault();
                        }
                      }}
                    />
                  </B.Col>
                  {
                    hideSendButton ? undefined : (
                      <B.Col xs={3} sm={3} md={3}>
                      <B.Button bsStyle="primary" bsSize="large" className="chat-send-btn" onClick={this.sendMessage.bind(this)} disabled={this.props.sendDisabled}>
                        {
                          configuration.glyphRegEx().test(this.props.queueProperties.sendButtonLabel)
                            ? <B.Glyphicon glyph={configuration.glyphRegEx().exec(this.props.queueProperties.sendButtonLabel)[1]} />
                            : this.props.queueProperties.sendButtonLabel
                        }
                      </B.Button>
                    </B.Col>
                    )
                  }
                </B.Row>
              </B.Grid>
            </div>
          )
        }
      </div>
    );
  }
}

export default ChatTextWraper;



// WEBPACK FOOTER //
// ./components/chat/ChatTextWraper.js